"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
import makePadding from "../utils/make-padding.js";
export const paddings = {
    small: { x: 12, y: "xs" },
    medium: { x: 12, y: "sm" },
    large: { x: 12, y: 12 },
};
function validationStyle(palette, focused, valid, disabled, theme) {
    switch (valid) {
        case true:
        case "valid": {
            return Object.assign({ backgroundColor: disabled ? palette.disabled.backgroundColor : palette.valid.backgroundColor, borderColor: palette.valid.borderColor }, (focused && {
                boxShadow: theme.outline(palette.valid.focus.boxShadowColor),
            }));
        }
        case false:
        case "invalid": {
            return Object.assign({ backgroundColor: disabled ? palette.disabled.backgroundColor : palette.invalid.backgroundColor, borderColor: palette.invalid.borderColor }, (focused && {
                boxShadow: theme.outline(palette.invalid.focus.boxShadowColor),
            }));
        }
        default: {
            return {};
        }
    }
}
const useStyles = makeStyles()((theme, { block, color, disabled, focused, shadow, size, valid, variant }) => {
    var _a;
    const palette = theme.palette(color).input[variant];
    const padding = makePadding(paddings, theme);
    const disabledStyles = {
        color: palette.disabled.color,
        backgroundColor: palette.disabled.backgroundColor,
        borderColor: palette.disabled.borderColor,
        cursor: "not-allowed",
        userSelect: "none",
    };
    const focusedStyle = {
        borderColor: palette.focus.borderColor,
        boxShadow: theme.outline(palette.focus.boxShadowColor),
    };
    return {
        box: Object.assign(Object.assign(Object.assign(Object.assign({ "display": !!block ? "flex" : "inline-flex", "flexGrow": !!block ? 1 : undefined, "alignItems": "center", "width": block ? "100%" : undefined, "padding": !!size ? padding(size, theme.size(1)) : undefined, "fontSize": theme.typography.body.fontSize, "verticalAlign": "middle", "color": palette.color, "backgroundColor": palette.backgroundColor, "border": `${theme.size(1)} solid`, "borderColor": palette.borderColor, "borderRadius": theme.size(4), "boxShadow": !disabled && !!shadow ? theme.shadow("sm") : undefined }, (disabled && disabledStyles)), (focused && focusedStyle)), validationStyle(palette, focused, valid, disabled, theme)), { "& input::placeholder, & input[type=date]:invalid::-webkit-datetime-edit": {
                color: disabled ? (_a = palette.disabled.placeholder) === null || _a === void 0 ? void 0 : _a.color : palette.placeholder.color,
                opacity: 1,
            } }),
    };
});
export const inputDefaultShadows = {
    outline: false,
    flat: false,
    filled: true,
};
export const InputBox = React.forwardRef(function InputBox(_a, ref) {
    var { block, className, color = "primary", disabled, focused, size, valid, variant = "outline", shadow = inputDefaultShadows[variant] } = _a, props = __rest(_a, ["block", "className", "color", "disabled", "focused", "size", "valid", "variant", "shadow"]);
    const { classes, cx } = useStyles({ block, color, disabled, focused, shadow, size, valid, variant });
    return _jsx("label", Object.assign({ ref: ref, className: cx(classes.box, className) }, props));
});
export default InputBox;
//# sourceMappingURL=input-box.js.map